import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Seo from '../components/Seo';
import { Sparkles, Users, Rocket, Heart, Award, Target, CheckCircle2 } from 'lucide-react';
import { teamValues } from '../mock/mockData';

const iconMap = { Sparkles, Users, Rocket, Heart };

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Seo
        title="À propos — Medelia & la formation continue"
        description="Medelia simplifie la formation continue des professionnels de santé : catalogue Qualiopi, conseils et accompagnement sur le financement (DPC, FIFPL, OPCO, CPF) en France."
        canonicalPath="/a-propos"
      />
      <Navbar />
      <main className="safe-pt-nav">
        <section className="relative py-20 bg-gradient-to-br from-teal-50 via-white to-emerald-50/40 overflow-hidden">
          <div className="absolute -top-24 -right-24 w-[500px] h-[500px] bg-teal-200/30 rounded-full blur-3xl" />
          <div className="relative max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <span className="text-teal-600 text-sm font-bold uppercase tracking-widest">À propos</span>
              <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-slate-900 mt-3 tracking-tight leading-[1.05]">
                Simplifier la formation continue des professionnels de santé
              </h1>
              <p className="text-lg text-slate-600 mt-6 leading-relaxed max-w-xl">Medelia est née d'un constat simple : les professionnels de santé passent trop de temps à chercher la bonne formation et à gérer les démarches administratives. Nous rendons tout cela facile, rapide et transparent.</p>
            </div>
            <div className="relative">
              <img src="https://images.unsplash.com/photo-1731357266501-fc8594f84707?w=900" alt="Équipe médicale" className="rounded-3xl shadow-2xl shadow-slate-900/15 aspect-[4/3] object-cover w-full" />
              <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-5 border border-slate-100">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-xl bg-teal-50 flex items-center justify-center">
                    <Award className="w-6 h-6 text-teal-600" />
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-slate-900">Qualiopi</p>
                    <p className="text-xs text-slate-500">Certifié depuis 2021</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-20">
          <div className="max-w-7xl mx-auto px-5 lg:px-8">
            <div className="text-center max-w-2xl mx-auto mb-14">
              <span className="text-teal-600 text-sm font-bold uppercase tracking-widest">Nos valeurs</span>
              <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mt-3 tracking-tight">Ce qui nous guide au quotidien</h2>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
              {teamValues.map((v, i) => {
                const Icon = iconMap[v.icon];
                return (
                  <div key={i} className="bg-gradient-to-br from-white to-slate-50/50 border border-slate-200 rounded-2xl p-7 hover:border-teal-300 hover:shadow-lg transition-all">
                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-teal-500 to-emerald-600 flex items-center justify-center shadow-md shadow-teal-500/25 mb-5">
                      <Icon className="w-6 h-6 text-white" />
                    </div>
                    <h3 className="font-bold text-slate-900 mb-2">{v.title}</h3>
                    <p className="text-sm text-slate-600 leading-relaxed">{v.desc}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <section className="py-20 bg-slate-50/60">
          <div className="max-w-5xl mx-auto px-5 lg:px-8">
            <div className="grid md:grid-cols-2 gap-10 items-center">
              <div>
                <span className="text-teal-600 text-sm font-bold uppercase tracking-widest">Notre mission</span>
                <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mt-3 tracking-tight mb-5">Révolutionner l'accès à la formation médicale</h2>
                <ul className="space-y-3">
                  {[
                    'Centraliser les meilleures formations du marché',
                    'Optimiser la prise en charge DPC, FIFPL, OPCO, CPF',
                    'Accompagner chaque professionnel individuellement',
                    'Garantir un contenu pédagogique d\'excellence',
                  ].map((item, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <CheckCircle2 className="w-5 h-5 text-teal-600 shrink-0 mt-0.5" />
                      <span className="text-slate-700">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="relative rounded-3xl overflow-hidden shadow-xl">
                <img src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800" alt="Formation médicale" className="w-full aspect-square object-cover" />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
